<template>
  <ManualOrders location="ny"> </ManualOrders>
</template>

<script>
import ManualOrders from "../components/ManualOrders";

export default {
  components: {
    ManualOrders
  }
};
</script>
